export enum EChatsActionTypes {
  StateReceived = 'IChatsStateReceived',
  OfferChatReceived = 'IOfferChatReceived',
  OpenChat = 'IOpenChat',
  CloseChat = 'ICloseChat',
}

export type TChatAction = IChatsStateReceived | IOfferChatReceived | IOpenChat | ICloseChat;

export interface IChatsStateReceived {
  type: EChatsActionTypes.StateReceived;
  payload: {
    enabled: boolean;
  };
}

export const chatsStateReceived = (enabled: boolean): IChatsStateReceived => ({
  payload: { enabled },
  type: EChatsActionTypes.StateReceived,
});

export interface IOfferChatReceived {
  type: EChatsActionTypes.OfferChatReceived;
  payload: {
    chatId: string;
  };
}

export const offerChatReceived = (chatId: string): IOfferChatReceived => ({
  payload: { chatId },
  type: EChatsActionTypes.OfferChatReceived,
});

export interface IOpenChat {
  type: EChatsActionTypes.OpenChat;
  payload: {
    type?: 'open_phone' | 'open_message';
  };
}

export const openChat = (type?: 'open_phone' | 'open_message'): IOpenChat => ({
  type: EChatsActionTypes.OpenChat,
  payload: {
    type,
  },
});

export interface ICloseChat {
  type: EChatsActionTypes.CloseChat;
}

export const closeChat = (): ICloseChat => ({
  type: EChatsActionTypes.CloseChat,
});
